module.exports = __webpack_public_path__ + "img/ireland.7b846ffb.svg";